
import { tApi } from 'tplus-api';
import {localCache_prefix, partnerVoucherTemplateNames,voucherTemplate_param_key} from '../config/templateConst';
import {tools} from 'tplus-voucher';
import mock from '../module_biz/mock';


export default class TemplateUtil {

  static tempalteExist(){
    let templateParam = tools.getLocalCache(voucherTemplate_param_key);
    return templateParam ? true : false;
  }

  /**模板下载相关**/
  static async refreshTemplate() {
    //取出模板请求参数
    let templateParam = tools.getLocalCache(voucherTemplate_param_key);
    let templateObjs = {};
    if (templateParam) {
      partnerVoucherTemplateNames.forEach((templateName, index) => {
        //读取模板缓存
        templateObjs[templateName] = tools.getLocalCache(localCache_prefix + templateName);
        console.log(templateName + "===================cached", templateObjs[templateName]);
      });
    }

    //if (!templateParam) {
    if(true){
      let defaultParam = {};
      //补充参数默认值
      const templatesJsonObj =  tools.getLocalCache(voucherTemplate_param_key);
      if(templatesJsonObj){
        defaultParam.templatesJson = templatesJsonObj.templatesJson;
      }else{
        defaultParam.templatesJson = JSON.stringify(partnerVoucherTemplateNames.map((item, index) => {
          return { 'TemplateName': item, 'Ts': '' };
        }));
      }
     
      templateParam = defaultParam;
    }
    let method = 'Ufida.T.EAP.IMBVoucherDesign.GetMbTemplate';
    const resp = await tApi(templateParam, method, false);
    let templates = resp.Template;
    //let templates = mock.UITemplate.Template;
    if (templates && templates.length > 0) {
      //更新三处缓存  templdateParam  + 两个模板信息
      //更新templateParam 参数信息  主要处理TS的变化
      let templateJsonArray = new Array();
      let refreshTemplateNames = ',';
      templates.forEach((template, index) => {
        templateObjs[template.TemplateName] = template;
        console.log(template.TemplateName + "===================", template);
        //更新模板localstorage的缓存
        tools.setLocalCache(localCache_prefix + template.TemplateName, JSON.stringify(template));
        templateJsonArray.push({ 'TemplateName': template.TemplateName, 'Ts': template.Ts });
        refreshTemplateNames = refreshTemplateNames + template.TemplateName + ',';
      });
      if (templateParam && templateParam.templatesJson && templateParam.templatesJson != '') {
        //将没有更新的模板请求参数补全
        const templatesJson = JSON.parse(templateParam.templatesJson);
        //merge (本地模板请求参数,更新后的参数)
        templatesJson.forEach((item, index) => {
          if (refreshTemplateNames.indexOf(item.TemplateName + ',') == -1) {
            templateJsonArray.push(item);
          }
        });
      }
      console.log('template param ===============', templateJsonArray);
      //将更新后的请求信息缓存到localstorage
      tools.setLocalCache(voucherTemplate_param_key, JSON.stringify({ 'templatesJson': JSON.stringify(templateJsonArray) }));

    }
    return templateObjs;
  }


}
